// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c529cda","453":"47b8019e","455":"3a2a2015","977":"6580cd51"}[chunkId] + ".chunk.js";
};